import { compose, withHandlers, withProps } from 'recompose';

import { debouncedGetHandlingOperators } from 'redux/modules/journey-handling/effects';

import AssignAgentSelector from './component';

const enhance = compose(
  withHandlers({
    handleChange:
      ({ onChange }) =>
      (value) => {
        if (onChange) {
          onChange({ agent: value });
        }
      },
  }),
  withProps(({ filterUserGroups = 'FLEET,ProdTech' }) => ({
    loadOptions: debouncedGetHandlingOperators(filterUserGroups),
  }))
);

export default enhance(AssignAgentSelector);
